import { LoadWorkFinishOptionList } from '@/javascript/domain/usecases'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'
import { HttpClient, HttpStatusCode } from '../protocols/http'

export class RemoteLoadWorkFinishOptionList implements LoadWorkFinishOptionList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadWorkFinishOptionList.Response>
  ) {}

  async load(searchText?: string): Promise<LoadWorkFinishOptionList.Model[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params: {
        q: searchText
      }
    })
    const response = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return formatResponse(response)
      case HttpStatusCode.noContent: return []
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteLoadWorkFinishOptionList {
  export type WorkFinishOption = {
    id: number
    name: string
  }
  export type Response = WorkFinishOption[]
}

const formatResponse = (finishOptions: RemoteLoadWorkFinishOptionList.Response): LoadWorkFinishOptionList.Model[] => {
  return finishOptions?.map(finishOption => ({
    id: finishOption.id,
    name: finishOption.name,
  })) || []
}
